import { createContext, useContext } from "react";
export const initialState = { showLightbox: false, url: "" };
export const ActionStateContext = createContext(initialState);
export const useActionState = () => useContext(ActionStateContext);
//# sourceMappingURL=action-state.js.map